import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SkeletonCircle, SkeletonLine } from './Skeleton';

const PendingAppointmentSkeleton = ({ className }) => {
	return (
		<tr className={classNames(className)}>
			<td className='align-middle'>
				<div className='d-flex align-items-center gap-3'>
					<SkeletonCircle size='2.75rem' />
					<div className='flex-grow-1'>
						<SkeletonLine width='72%' height='0.95rem' />
						<SkeletonLine className='mt-2' width='50%' height='0.75rem' />
					</div>
				</div>
			</td>
			<td className='align-middle'>
				<SkeletonLine width='78%' height='0.9rem' />
			</td>
			<td className='align-middle'>
				<SkeletonLine width='66%' height='0.9rem' />
			</td>
			<td className='align-middle'>
				<SkeletonLine width='82%' height='0.9rem' />
			</td>
			<td className='align-middle'>
				<div className='d-flex flex-column gap-2'>
					<SkeletonLine width='86%' height='0.9rem' />
					<SkeletonLine width='54%' height='0.8rem' />
				</div>
			</td>
			<td className='align-middle'>
				<SkeletonLine width='74%' height='0.9rem' />
			</td>
			<td className='align-middle'>
				<SkeletonLine width='64%' height='0.9rem' />
			</td>
			<td className='align-middle'>
				<SkeletonLine width='72%' height='0.9rem' />
			</td>
			<td className='align-middle'>
				<SkeletonLine width='66%' height='0.9rem' />
			</td>
			<td className='align-middle'>
				<SkeletonLine width='72px' height='1.5rem' rounded='pill' />
			</td>
			<td className='align-middle'>
				<div className='d-flex justify-content-end gap-2'>
					<SkeletonLine width='44px' height='2rem' rounded='pill' />
					<SkeletonLine width='44px' height='2rem' rounded='pill' />
				</div>
			</td>
		</tr>
	);
};

PendingAppointmentSkeleton.propTypes = {
	className: PropTypes.string,
};

PendingAppointmentSkeleton.defaultProps = {
	className: null,
};

export default PendingAppointmentSkeleton;
